import { render } from "./NewsCardShimmer.vue?vue&type=template&id=6dff95b4"
const script = {}
script.render = render

export default script